import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";

export namespace DatatablesHelper {
  export type SearchHandler = (settings: any, data: any, dataIndex: number) => boolean;

  export function attachSearch(handler: SearchHandler) {
    // We need to call the $.fn.dataTable like this because DataTables typings do not have the "ext" property
    $.fn['dataTable'].ext.search.push(handler);
  }

  export function detachSearch(handler?: SearchHandler) {
    const search = $.fn['dataTable'].ext.search;

    if (handler) {
      const index = search.indexOf(handler);
      if (index >= 0) search.splice(index, 1);
    } else {
      // We remove the last function in the global ext search array so we do not add the fn each time the component is drawn
      // /!\ This is not the ideal solution as other components may add other search function in this array, so be careful when
      // handling this global variable
      search.pop();
    }
  }

  export function redrawTable(element: DataTableDirective, dtTrigger: Subject<any>) {
    element.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      dtTrigger.next();
    });
  }

  export function stripHtml(data: string) {
    const Buttons = ($.fn.dataTable as any).Buttons;
    const html = data.replace(/(<br)/gi, '\n$1'); // prepend <br> with newlines (cut)
    const text = Buttons.stripData(html, { stripHtml: true, trim: true });
    return text;
  }
}
